import { render, staticRenderFns } from "./BlogListTwoColSec.vue?vue&type=template&id=73ca1f4a&scoped=true&"
import script from "./BlogListTwoColSec.vue?vue&type=script&lang=js&"
export * from "./BlogListTwoColSec.vue?vue&type=script&lang=js&"
import style0 from "./BlogListTwoColSec.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BlogListTwoColSec.vue?vue&type=style&index=1&id=73ca1f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ca1f4a",
  null
  
)

export default component.exports